const all_modules = require('./all_modules_timetable.json')
const module_details = require('./module_details.json')
export const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const time = [
  "08:00", "09:00", "10:00", "11:00", "12:00", 
  "13:00", "14:00", "15:00", "16:00", 
  "17:00", "18:00", "19:00"
];

export const moduleTimes = all_modules
export const moduleDetails = module_details
